import {
    Flex,
    Box,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionIcon,
    AccordionPanel
} from "@chakra-ui/react";
import { StyleSheet, css } from "aphrodite";
import { useSelector } from "react-redux";

function Training () {

    const isMobile = useSelector(state => state.windowSize.isMobile);

    return (
        <>

        <Box className={css(styles.head)}>
            <Flex className={css(styles.container)}>
                PROGRAM SUMMARY
            </Flex>
            <Box className={css(styles.textbox)} textAlign={isMobile ? 'center' : 'left'}>
            SITE-CAV (Secure, Intelligent and Trustworthy Ecosystem of Connected and Autonomous Vehicles) is a 
            collaborative and interdisciplinary project to enable smooth integration of connected and autonomous 
            vehicles (CAVs) into the evolving transportation ecosystem in Ontario. Research questions that will 
            be addressed by the project team involve the development of efficient and reliable communication protocols 
            integrated with security-by-design solutions along with intelligent, user friendly and legal-aware 
            decision support systems. Four key pillars of the research project include: 1) a diverse team 
            of research groups that bring complementary expertise in the areas of 5G communications, vehicular ad hoc 
            networks, security, human factors and legal implications of CAV integration into intelligent transportation systems, 
            2) two experimental test beds; more specifically a heterogeneous autonomous vehicles network research test bed 
            at the University of Ottawa, and a driving simulation test bed with human factors and applied statistics 
            located at the University of Toronto.  These two experimental test beds are aimed to be bridged with 
            the capabilities of the optimized computing and communications lab at Western University that focuses on 
            network virtualization, resiliency and big data challenges related to 5G/6G networks, 3) Strong commercialization 
            plan with industry engagement to facilitate security, decision support, legal-awareness, supply chain optimization 
            and ultra-fast connectivity solutions for the next generation of connected and autonomous vehicles, 4) Use of the 
            interactive and experiential learning Cyber Range facility at uOttawa for the trainees concerning cyber-attack 
            management and organizational response in a CAV setting.
            </Box>
            <hr />
        </Box>




        <Box className={css(styles.head_2)}>
            <Flex className={css(styles.container)}>
                RESEARCH & TRAINING
            </Flex>
            <Flex className={css(styles.accordion)}>
                <Accordion Accordion allowToggle width='100%' allowMultiple>
                    <AccordionItem>
                        <AccordionButton>
                            <Box
                            as="span"
                            flex='1'
                            textAlign='left'
                            fontSize={20}
                            fontWeight='bold'>
                                Workshop
                            </Box>
                            <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={4} fontSize={16} textAlign={isMobile ? 'center' : 'left'}>
                            <b>The Annual SITE-CAV Workshop</b> is a key event where trainees engage with industry and academic 
                            experts through talks, panels, and research showcases. This gathering fosters networking 
                            opportunities and explores themes aligned with the program's scope. 
                        </AccordionPanel>
                    </AccordionItem>
                    
                    <AccordionItem>
                        <AccordionButton>
                            <Box
                            as="span"
                            flex='1'
                            textAlign='left'
                            fontSize={20}
                            fontWeight='bold'>
                                Hacakthon
                            </Box>
                            <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={4} fontSize={16} textAlign={isMobile ? 'center' : 'left'}>
                            <b>The SITE-CAV Hackathon</b> is an annual event that brings together second-year graduate students 
                            from the projects. Co-chaired by two co-applicants, this intensive 48-hour event challenges 
                            students to collaborate in diverse teams and tackle research problems related to autonomous 
                            decision-making for AV.
                        </AccordionPanel>
                    </AccordionItem>
                    <AccordionItem>
                        <AccordionButton>
                            <Box as="span"
                            flex='1'
                            textAlign='left'
                            fontSize={20}
                            fontWeight='bold'>
                                Seminars
                            </Box>
                            <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={4} fontSize={16} textAlign={isMobile ? 'center' : 'left'}>
                            <b>The SITE-CAV seminars</b> demonstrate a broad spectrum of topics, including breakthrough 
                            research, technology commercialization, and entrepreneurship in Connected and Autonomous 
                            Vehicles. Bringing together expert speakers from around the world, these sessions 
                            provide a valuable forum for knowledge exchange, collaboration, and professional networking.
                        </AccordionPanel>
                    </AccordionItem>
                </Accordion>
            </Flex>
        </Box>

        <Box className={css(styles.head_2)}>
            <Flex className={css(styles.container)}>
                COMMERCIALIZATIONS
            </Flex>
            <Box className={css(styles.textbox)} textAlign={isMobile ? 'center' : 'left'}>
                SITE-CAV is developing efficient and reliable communication protocols integrated with 
                security-by-design frameworks; along with smart, user friendly and legal-aware decision support. 
                This will help ensure Ontario develops connected and autonomous transportation systems to handle 
                increased traffic, while reducing emissions.            
            </Box>
            <hr />
        </Box>

        <Box className={css(styles.head_2)}>
            <Flex className={css(styles.container)}>
                INTERNSHIPS
            </Flex>
            <Box className={css(styles.textbox)} textAlign={isMobile ? 'center' : 'left'}>
                The trainees of the SITE-CAV project connect with a large number of industry partners, 
                and work directly with them on deployment and integration challenges of the secure, trustworthy 
                and intelligent CAV ecosystem through various means of collaborations including externally funded 
                research projects and internship. In many cases this is expected to lead to job 
                opportunities with these graduates and postdocs.
            </Box>
            <hr />
        </Box>

        <Box className={css(styles.head_2)}>
            <Flex className={css(styles.container)}>
                YOUTH OUTREACH
            </Flex>
            <Box className={css(styles.textbox)} textAlign={isMobile ? 'center' : 'left'}>
                The Youth Outreach Plan is divided into two categories, namely those events we stage and those that are 
                ad hoc. In respect to events we stage, primarily at uOttawa, there are Annual Workshops comprised 
                of seminars and poster sessions to which local youth will be invited through means discussed below. 
                In addition, there are opportunities around the workshops to have tours of the Smart Connected Vehicles 
                Innovation Centre, which includes an indoor AV test track. Graduate students will provide discussion 
                and demonstrations at the Centre.
                <br /><br />
                The Faculty of Engineering at uOttawa frequently hosts public events for pre-university youth such 
                as maker space projects, competitions, lab tours and lectures. The project team EM will liaise 
                with Faculty organizers of these events to offer participation by members of the SITE-CAV 
                project team over the course of the project. 
            </Box>
            <hr />
        </Box>

        

        </>
    )
}

const styles = StyleSheet.create({
    head: {
        maxWidth: '100vw',
        marginTop: 140
    },
    head_2: {
        maxWidth: '100vw'
    },
    container: {
        maxWidth: '100%',
        justifyContent: 'center',
        fontSize: 24,
        margin: '1%',
        fontWeight: 'bolder',
        textShadow: '1px 1px gray',
    },
    accordion: {
        maxWidth: '100vw',
        textAlign: 'center',
        paddingBottom: 0,
        margin: '1%'
    },
    textbox: {
        margin: '2%',
        marginTop: '0%',
        marginBottom: '1%',
        textAlign: 'justify',
        fontSize: 18
    }
})

export default Training